export const SET_BANNER = 'setBanner'
export const BANNER_RESET_STATE = 'bannerResetState'